<template>
  <scrollview class="CharactersTableList">
    <div class="characters">
      <div class="character" v-for="{ key, params } in characters" :key="key">
        <div class="head">
          <div class="image" v-if="get(key)" :style="{
            backgroundImage: url(get(key).imageKey)
          }">
          </div>
          <p class="dex" v-if="get(key)" v-text="get(key).params.dex"></p>
        </div>
        <div class="body" v-if="get(key)">
          <div class="param" :class="param.key" v-for="(param, i) in characterParamList" :key="i">
            <div class="paramHead">
              <p>{{param.name.slice(0, 5) || 'null'}}: {{Number(params[param.key] || 0)}}/{{Number(get(key).params[param.key] || 0)}}</p>
              <div class="control">
                <faicon class="down" icon="minus" @click="addParam(key, param.key, -1)" />
                <faicon class="up" icon="plus" @click="addParam(key, param.key, 1)" />
              </div>
            </div>
            <bar v-if="param.key in get(key).params" :max="Number(get(key).params[param.key])" :value="Number(params[param.key])" @change="value => setParam(key, param.key, value)" :colors="{ u80: '#900', u50: '#c00' }"></bar>
          </div>
        </div>
        <div class="menu">
          <a @click.prevent="remove(key)">
            <faicon icon="times" class="icon" />
          </a>
          <a @click.prevent="current(key)">
            <faicon icon="dice" class="icon" />
          </a>
          <a @click="reply(key)">
            <faicon icon="reply" class="icon" />
          </a>
          <a @click="openDetail(key)">
            <faicon icon="user-cog" class="icon" />
          </a>
        </div>
      </div>
    </div>
    <div v-if="role > 5" class="characters-for-kp">
      <h2>秘匿キャラクター一覧(KP)</h2>
      <div v-if="role > 5" class="character-m" v-for="{ key, params } in charactersForKP" :key="key">
        <div class="head">
          <figure class="image">
            <img v-if="get(key) && get(key).imageKey" :src="src(get(key).imageKey)" alt="">
          </figure>
          <p class="dex" v-if="get(key)" v-text="get(key).params.dex"></p>
        </div>
        <div class="body" v-if="get(key)">
          <div class="param" :class="param.key" v-for="param in characterParamList.slice(0, 2)" :key="param.key">
            <p>
              {{param.name.slice(0, 5) || 'null'}}: {{Number(params[param.key] || 0)}}/{{Number(get(key).params[param.key] || 0)}}
              <faicon class="down" icon="minus" @click="addParam(key, param.key, -1, true)" />
              <faicon class="up" icon="plus" @click="addParam(key, param.key, 1, true)" />
            </p>
          </div>
        </div>
        <div class="menu">
          <a @click.prevent="remove(key)">
            <faicon icon="times" class="icon" />
          </a>
          <a @click.prevent="current(key)">
            <faicon icon="dice" class="icon" />
          </a>
        </div>
      </div>
    </div>
  </scrollview>
</template>

<script>
import draggable from '../common/draggable'
import bar from '../common/bar'

export default {
  components: { bar, draggable },
  data() {
    return {
      timers: {}
    }
  },
  computed: {
    characters() {
      return this.$store.getters['characterList/$items'].filter(({ key }) => {
        const data = this.get(key)
        return data && !data.hidden
      }).sort((a, b) => {
        const aData = this.get(a.key)
        const bData = this.get(b.key)
        if (!aData) {
          return -1
        }
        if (!bData) {
          return 1
        }
        return Number(bData.params.dex) - Number(aData.params.dex)
      })
    },
    charactersForKP() {
      return this.$store.getters['characterList/$items'].filter(({ key }) => {
        const data = this.get(key)
        return data && data.hidden
      }).sort((a, b) => {
        const aData = this.get(a.key)
        const bData = this.get(b.key)
        if (!aData) {
          return -1
        }
        if (!bData) {
          return 1
        }
        return Number(bData.params.dex) - Number(aData.params.dex)
      })
    },
    characterParamList() {
      return this.$store.getters['room/characterParamList'].filter(function(param) {
        return param.flex
      })
    },
    getFromList() {
      return this.$store.getters['characterList/$get']
    },
    get() {
      return this.$store.getters['characters/$get']
    },
    src() {
      return this.$store.getters['images/getSrc']
    },
    url() {
      return this.$store.getters['images/getBackgroundUrl']
    },
    role() {
      return this.$store.getters['local/role']
    }
  },
  methods: {
    addParam(key, paramKey, value, silent) {
      this.$store.dispatch('characterList/updateParam', { key, data: { key: paramKey, value } })
      clearTimeout(this.timers[key+paramKey])
      if (silent) return;
      this.timers[key+paramKey] = setTimeout(() => {
        const character = this.getFromList(key)
        if (character) {
          this.$store.dispatch('messages/$create', { to: null, channel: null, from: key, text: `${paramKey}が${character.params[paramKey]}になった。`, extend: {} })
        }
      }, 3000)
    },
    setParam(key, paramKey, value) {
      this.$store.dispatch('characterList/setParam', { key, data: { key: paramKey, value } })
      clearTimeout(this.timers[key+paramKey])
      this.timers[key+paramKey] = setTimeout(() => {
        const character = this.getFromList(key)
        if (character) {
          this.$store.dispatch('messages/$create', { to: null, channel: null, from: key, text: `${paramKey}が${character.params[paramKey]}になった。`, extend: {} })
        }
      }, 3000)
    },
    remove(key) {
      this.$store.dispatch('characterList/$remove', key)
    },
    current(key) {
      this.$store.dispatch('local/currentCharacterKey', key)
    },
    openDetail(key) {
      this.$store.commit('characters/$checkout', key)
    },
    reply(key) {
      const character = this.get(key)
      if (character) {
        this.$store.commit('local/addToList', key)
      }
    }
  }

}
</script>
<style scoped>
.CharactersTableList {
  box-sizing: border-box;
  padding: 10px;
  padding-right: 15px;
  width: 240px;
  position: absolute;
  top: 0;
  left: 0;
  max-height: 100%;
}
.characters {
  display: flex;
  flex-flow: column;
  /*justify-content: center;*/
  min-width: 100%;
  vertical-align: bottom;
}
.character {
  margin-bottom: 4px;
  display: flex;
  min-height: 40px;
  /* background: #30353E; */
  background: rgba(0, 0, 0, 0.4);
  color: #eee;
   box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
}
/*.character + .character {
  margin-top: 4px;
}*/
.character .head {
  position: relative;
  width: 55px;
  background: rgba(0, 0, 0, 0.2);
}
.character .head .image {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  /*cursor: pointer;*/
}
/* .character .head .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
} */
.character .head .dex {
  border-radius: 2px;
  padding: 2px 4px;
  position: absolute;
  bottom: 2px;
  left: 2px;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 10px;
}
.character .head .remove {
  padding: 4px 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  line-height: 1;
  box-shadow: none;
  background: #444;
  color: #fff;
  text-align: center;
  font-size: 10px;
}
/*.character .image svg {
  width: 100%;
  height: 100%;
  color: #ccc;
}*/
.character .body {
  padding: 5px;
  flex: 1;
/*  display: flex;
  flex-wrap: wrap;*/
}
.character .menu {
  padding: 5px;
  display: flex;
  flex-flow: column;
  background: rgba(0, 0, 0, 0.2);
}
.character .menu a {
  margin-bottom: 5px;
  display: block;
  line-height: 1;
  font-size: 10px;
  color: #fff;
  text-align: center;
}
.character .menu a:hover {
  color: #ccc;
}
.character .menu a .icon {
  width: 10px;
  height: 10px;
}
.character .body .param + .param {
  margin-top: 2px;
}
.character .body .param .paramHead {
  letter-spacing: 0.02em;
  font-size: 10px;
  display: flex;
  justify-content: space-between;
  /* color: #fff; */
}
.character .body .param .control {
}
.character .body .param .control svg {
  padding: 1px;
  cursor: pointer;
  width: 8px;
  height: 8px;
  background: rgba(0, 0, 0, 0.2);
}
.character .body .param .control svg + svg {
  margin-left: 3px;
}
.character .body .param .name {
  margin-top: 5px;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
}

.characters-for-kp {
  margin-top: 12px;
  padding-bottom: 30px;
}
.characters-for-kp h2 {
  border-left: 4px solid rgba(0, 0, 0, 0.4);
  margin-bottom: 4px;
  padding: 2px 5px;
  font-size: 10px;
  font-weight: normal;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
}
.character-m {
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  position: relative;
}
.character-m .dex {
  padding: 0 2px;
  border-radius: 0 2px 0 0;
  font-size: 10px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 0;
  bottom: 0;
}
.character-m .image {
  width: 36px;
  height: 36px;
  background: rgba(0, 0, 0, 0.2);
}
.character-m .image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.character-m .body {
  /* display: flex; */
  /* flex-wrap: wrap; */
  font-size: 10px;
  color: #eee;
  flex: 1;
}
.character-m .body p {
  letter-spacing: 0.02em;
}
.character-m .param {
  margin-left: 5px;
}
.character-m .up,
.character-m .down {
  padding: 1px;
  width: 8px;
  height: 8px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.2);
}
.character-m .down {
  margin-left: 4px;
}
.character-m .up {
  margin-left: 2px;
}
.character-m .menu {
  display: flex;
  flex-flow: column;
  align-items: center;
  height: 36px;
  background: rgba(0, 0, 0, 0.2);
}
.character-m .menu a {
  padding: 2px;
  line-height: 1;
  font-size: 0;
}
.character-m .menu a .icon {
  color: #fff;
  width: 8px;
  height: 8px;
}
</style>
